import React from 'react';
import { Typography } from '@mui/material';

interface LicenseTextProps {
  stateAbbreviation: string | null | undefined;
  licenseDisplayName: string | null | undefined;
  color?: 'textSecondary' | 'textPrimary';
}

export default function LicenseText({
  stateAbbreviation,
  licenseDisplayName,
  color = 'textSecondary',
}: LicenseTextProps) {
  if (!stateAbbreviation || !licenseDisplayName) {
    return null;
  }

  return (
    <Typography color={color}>
      {stateAbbreviation} • {licenseDisplayName}
    </Typography>
  );
}
